import { cn } from '@exam-room/utils';

import { BookmarkIcon } from '../icons';

export interface ExamOverviewItemProps extends React.ComponentProps<'button'> {
  size?: 'sm' | 'md';
  done?: string;
  current?: boolean;
  bookmarked?: boolean;
}

export default function ExamOverviewItem({
  children,
  size = 'md',
  done,
  current,
  bookmarked,
  className,
  ...props
}: ExamOverviewItemProps) {
  return (
    <button
      type='submit'
      className={cn(
        'border-grey-300 relative grid cursor-pointer place-items-center rounded-sm border',
        size === 'md' ? 'text-body1 size-10' : 'text-caption size-7',
        done && '!bg-success-300 !text-success border-transparent',
        current && '!border-success',
        className,
      )}
      {...props}
    >
      {children}
      {bookmarked ? (
        <BookmarkIcon
          className={cn(
            'text-warning absolute top-0 -right-[5px] z-10 -translate-y-1/3',
            size === 'md' ? 'text-xl' : 'text-base',
          )}
        />
      ) : null}
    </button>
  );
}
